import { useForm } from 'react-hook-form';

const useCustomForm = (props) => {
  const methods = useForm(props);
  const validate = (name, rules) => {
    const value = methods.getValues(name);

    if (!rules || Object.keys(rules).length === 0) return true;

    if ('required' in rules || value || String(value) !== '') {
      if (!value || String(value) === '') {
        methods.setError(name, {
          type: 'required',
          message: rules?.required,
        });
        return false;
      }

      if ('pattern' in rules) {
        if (!new RegExp(rules?.pattern?.value).test(value)) {
          methods.setError(name, {
            type: 'pattern',
            message: rules?.pattern?.message,
          });
          return false;
        }
      }
    }
    return true;
  };
  return { ...methods, validate };
};

export default useCustomForm;
